import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatPaginator, MatSort } from "@angular/material";

import { merge, Subject, of as observableOf } from "rxjs";
import {
  catchError,
  map,
  startWith,
  switchMap,
  takeUntil,
} from "rxjs/operators";

import { fuseAnimations } from "@fuse/animations";
import { InquiriesService } from "@app/main/content/inquiry/list/inquiries.service";
import { Inquiry, InquiryApi } from "@lbsdk/*";
import { environment } from "@env/environment";
import { FuseSplashScreenService } from "@fuse/services/splash-screen.service";
import { Router } from "@angular/router";
import { InquiryDatabase } from "./inquiry-database";

@Component({
  selector: "fuse-app-list",
  templateUrl: "./list.component.html",
  styleUrls: ["./list.component.scss"],
  animations: fuseAnimations,
})
export class ListComponent implements OnInit, AfterViewInit, OnDestroy {
  displayedColumns = ["image", "name", "subject", "message"];

  inquiryDatabase: InquiryDatabase | null;
  data: Inquiry[] = [];
  isRateLimitReached = false;

  s3BucketUrl = environment.s3BucketUrl;

  @ViewChild(MatPaginator)
  paginator: MatPaginator;

  @ViewChild(MatSort)
  sort: MatSort;

  @ViewChild("filter") filter: ElementRef;
  private _unsubscribeAll: Subject<any>;

  constructor(
    public _inquiriesService: InquiriesService,
    private _fuseSplashScreenService: FuseSplashScreenService,
    private _inquiryApi: InquiryApi,
    private router: Router
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this.inquiryDatabase = new InquiryDatabase(
      this._inquiryApi,
      this._inquiriesService
    );
    this.mergeData();
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  mergeData = (filterValue?) => {
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        takeUntil(this._unsubscribeAll),
        startWith({}),
        switchMap(() => {
          this._fuseSplashScreenService.show();
          return this.inquiryDatabase!.getData(
            this.sort.active,
            this.sort.direction,
            this.paginator,
            filterValue ? filterValue : ""
          );
        }),
        map((data) => {
          this._fuseSplashScreenService.hide();
          this.isRateLimitReached = false;
          return data;
        }),
        catchError(() => {
          this._fuseSplashScreenService.hide();
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      )
      .subscribe((data) => (this.data = this.transformingMessage(data)));
  };

  transformingMessage(inquires): any[] {
    inquires.forEach((el) => {
      if (el.message) {
        const msgs: any[] = JSON.parse(el.message);
        const index = msgs.length - 1;
        const keys = Object.keys(msgs[index]);
        el.message = { text: msgs[index][keys[0]], from: keys[0] };
      }
    });
    return inquires;
  }

  onInquiryClick = async (inquiry) => {
    this._fuseSplashScreenService.show();
    if (!inquiry.readByAdmin) {
      inquiry.readByAdmin = true;
      try {
        let response = await this._inquiriesService
          .updateInquiry(inquiry)
          .toPromise();
        this._fuseSplashScreenService.hide();
        if (!response) return;
        this.router.navigate([`inquires/detail/${inquiry.id}`]);
      } catch (error) {
        this._fuseSplashScreenService.hide();
        alert(error.message);
        return error;
      }
    } else {
      this._fuseSplashScreenService.hide();
      this.router.navigate([`inquires/detail/${inquiry.id}`]);
    }
  };
}
